import { useTranslation } from 'react-i18next';

export default function Art123GenerateResultModal({ result, onClose }) {
    const { t } = useTranslation();

    if (!result) {
        return null;
    }

    const {
        totalCount = 0,
        successCount = 0,
        failedCount = 0,
        successfulRecords = [],
        failedRecords = [],
    } = result;

    return (
        <div className="error-modal-overlay">
            <div className="error-modal result-modal">
                <div className="error-modal-header">
                    <span className="error-modal-title">
                        {t('staff.art123.generateResult.title')}
                    </span>
                    <button
                        type="button"
                        className="error-modal-close"
                        onClick={onClose}
                    >
                        ×
                    </button>
                </div>

                <div className="error-modal-body">
                    <div className="result-modal-summary">
                        <span>
                            {t('staff.art123.generateResult.total')}: <strong>{totalCount}</strong>
                        </span>
                        <span className="result-modal-summary__success">
                            {t('staff.art123.generateResult.success')}: <strong>{successCount}</strong>
                        </span>
                        <span className="result-modal-summary__failed">
                            {t('staff.art123.generateResult.failed')}: <strong>{failedCount}</strong>
                        </span>
                    </div>

                    {successfulRecords.length > 0 && (
                        <div className="result-modal-section result-modal-section--success">
                            <h5>{t('staff.art123.generateResult.successfulRecords')}</h5>
                            <ul>
                                {successfulRecords.map((record, index) => (
                                    <li key={`success-${record.contractId || record.empId || index}`}>
                                        {record.name}
                                        {record.empId != null ? ` (empId: ${record.empId})` : ''}
                                        {record.contractNo ? ` — ${record.contractNo}` : ''}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {failedRecords.length > 0 && (
                        <div className="result-modal-section result-modal-section--failed">
                            <h5>{t('staff.art123.generateResult.failedRecords')}</h5>
                            <ul>
                                {failedRecords.map((record, index) => (
                                    <li key={`failed-${record.correspondenceId || record.empId || index}`}>
                                        <div>
                                            {record.name}
                                            {record.empId != null ? ` (empId: ${record.empId})` : ''}
                                        </div>
                                        {(record.errors || []).map((errorMessage, errorIndex) => (
                                            <div
                                                key={`failed-${index}-error-${errorIndex}`}
                                                className="result-modal-error"
                                            >
                                                {errorMessage}
                                            </div>
                                        ))}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                <div className="error-modal-footer">
                    <button type="button" className="form-btn btn-blue" onClick={onClose}>
                        {t('common.continue')}
                    </button>
                </div>
            </div>
        </div>
    );
}
